import React from 'react';
const ChatUI = (props) => {
    return (
        <div>

        </div>
    )
}

export default ChatUI;